/* eslint-disable vue/component-name-in-template-casing */
export default {
  setPagingParams: function(pagingObj, meta) {
    pagingObj.page = meta.pagination.current_page;
    pagingObj.rowsPerPage = meta.pagination.per_page;
    pagingObj.totalItems = meta.pagination.total;
    pagingObj.totalPages = meta.pagination.total_pages;
    pagingObj.next = meta.pagination.links.next;
    pagingObj.prev = meta.pagination.links.previous;
    return pagingObj;
  },
  getQueryString: function(p,m) {
    
    let direction = p.sortDesc == true ? "&sortedBy=desc" : "&sortedBy=asc";
    let sortBy = "&orderBy=" + p.sortBy;
    let page = "?page=" + p.page;
    let limit =
      p.itemsPerPage === -1 ? "&limit=" + m : "&limit=" + p.itemsPerPage;
    let queryParams = page + sortBy + direction + limit;
    return queryParams;
  },
  errorResponse: function(err) {
    let errors = err.response.data.errors;
    let messages = [];
    if (errors) {
      for (let field in errors) {
        messages[field] = errors[field];
      }
    }
    return messages;
  }
};
